import * as buttons from 'smg/buttons';
import * as contact from 'smg/customer-api/contact';
import { Session } from 'smg/customer-api/session';
import { Phone } from 'smg/phone';
import * as uploads from 'smg/uploads';
import { GetFirstAndLast } from 'smg/users';
import { Relref } from '../hugo';

declare interface myWindow extends Window {
    dataLayer: Record<string, unknown>[];
}
declare const window: myWindow;

export default async function main() {
    const fullName = document.querySelector('#full-name') as HTMLInputElement;
    const company = document.querySelector('#company') as HTMLInputElement;
    const email = document.querySelector('#email') as HTMLInputElement;
    const notes = document.querySelector('#notes') as HTMLTextAreaElement;
    const phone = document.querySelector('#phone') as HTMLInputElement;
    const preferSMS = document.querySelector<HTMLInputElement>('#sms-opt-in');
    const form = document.querySelector('#form') as HTMLFormElement;
    const fieldset = form.querySelector('fieldset') as HTMLFieldSetElement;
    const confirm = form.querySelector('[type="submit"]') as HTMLButtonElement;
    const alert = form.querySelector('.alert') as HTMLElement;
    const header = document.querySelector('h1') as HTMLElement;
    const uploadsLabel = form.querySelector('#uploads') as HTMLLabelElement;

    alert.parentElement?.removeChild(alert);
    alert.classList.remove('d-none');

    const p = new Phone(phone);

    try {
        const sess = await Session();
        fullName.value = sess.firstName + ' ' + sess.lastName;
        email.value = sess.email;
        void p.Iti.promise.then(() =>
            p.Iti.setNumber(sess.phone));
        company.value = sess.company;
    } catch (err) {
        console.error(err);
    }

    const showAlert = (type: 'generic' = 'generic') => {
        const a = alert.cloneNode(true) as HTMLElement;
        const msg = a.querySelector(`.${type}`);
        msg?.classList.remove('d-none');

        header.after(a);
    };

    const hideAlert = () => {
        const a = form.querySelector('.alert');
        a?.parentElement?.removeChild(a);
    };

    const u = new uploads.Uploader(uploadsLabel, {
        confirmBtn: confirm,
        thumbnails: document.querySelector('#uploads-thumbnails') as HTMLElement,
    });

    form?.addEventListener('submit', e => {
        e.preventDefault();

        hideAlert();
        fieldset.setAttribute('disabled', 'disabled');
        buttons.Start(confirm);
        contact.CreateContact({
            name: fullName.value,
            company: company.value,
            phone: p,
            email: email.value,
            preferSMS: preferSMS?.checked,
            content: notes.value,
            uploader: u,
            $reCaptchaPlaceholder: form.querySelector('.contact-recpatcha-parent') as HTMLElement,
        }).then(async () => {
            const sess = await Session().catch(() => undefined);
            const dataLayer = window.dataLayer || [];
            const { firstName, lastName } = GetFirstAndLast(String(fullName.value));
            dataLayer.push({
                'event': 'hugo-contact-submit',
                'userData': {
                    'email': sess?.email || email.value,
                    'phone': sess?.phone || await p.Format(),
                    'firstName': sess?.firstName || firstName,
                    'lastName': sess?.lastName || lastName,
                },
            });

            window.location.href = Relref('/contact/success');
        }).catch(err => {
            console.error(err);
            fieldset.removeAttribute('disabled');
            buttons.Stop(confirm);

            if (err !== contact.ReCaptchaError) {
                showAlert();
            }
        });
    });
}